<template>
    <div>
        <b-alert show>
            <h5>RENDIMENTOS ANUAIS</h5>
            <b-row>
                <b-col sm="12" md="3">
                    <b-form-group>
                        <label>Ano-calendário</label>
                        <b-form-select
                            :plain="true"
                            :options="anosCalendario"
                            v-model="anoCalendario"
                        ></b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-alert>
        <b-alert v-if="!dirf" show variant="warning">Não existe DIRF para ano-calendário selecionado</b-alert>
        <b-row v-if="dirf">
            <b-col sm="12" md="6">
                <b-card>
                    <h5 class="heading-1">
                        <span>FONTE PAGADORA</span>
                    </h5>
                    <app-k-v
                        titulo="CNPJ"
                        :md="md"
                        :lg="lg"
                        :xl="xl"
                        :dado="dirf.cnpjPagadora ? $maskCpfCnpj(dirf.cnpjPagadora) : ''"
                    ></app-k-v>
                    <app-k-v titulo="Nome" :md="md" :lg="lg" :xl="xl" :dado="dirf.nomePagadora"></app-k-v>
                </b-card>
            </b-col>
            <b-col sm="12" md="6">
                <b-card>
                    <h5 class="heading-1">
                        <span>BENEFICIÁRIO</span>
                    </h5>
                    <app-k-v
                        titulo="CNPJ"
                        :md="md"
                        :lg="lg"
                        :xl="xl"
                        :dado="dirf.cnpjBeneficiario ? $maskCpfCnpj(dirf.cnpjBeneficiario) : ''"
                    ></app-k-v>
                    <app-k-v titulo="Nome" :md="md" :lg="lg" :xl="xl" :dado="dirf.nomeBeneficiario"></app-k-v>
                </b-card>
            </b-col>
        </b-row>
        <b-row v-if="dirf">
            <b-col sm="12" md="6">
                <rendimentos
                    :dirfBeneficiarioId="dirf ? dirf.dirfBeneficiarioId : ''"
                    :beneficiario="dirf ? dirf.nomeBeneficiario : ''"
                    :anoCalendario="dirf ? dirf.anoCalendario : ''"
                    :rendimentos="dirf.valores ? dirf.valores.rendimentos : []"
                    :dirfsServicos="obterDirfsServicos()"
                    :fornecedorId="fornecedorId"
                ></rendimentos>
            </b-col>
            <b-col sm="12" md="6">
                <pagamentos
                    :dirfBeneficiarioId="dirf ? dirf.dirfBeneficiarioId : ''"
                    :beneficiario="dirf ? dirf.nomeBeneficiario : ''"
                    :anoCalendario="dirf ? dirf.anoCalendario : ''"
                    :pagamentos="dirf.valores ? dirf.valores.pagamentos : []"
                    :dirfsServicos="obterDirfsServicos()"
                    :fornecedorId="fornecedorId"
                ></pagamentos>
            </b-col>
        </b-row>
    </div>
</template>

<script>
import DirfsServicos from './DirfsServicos'
import Rendimentos from './../../dirfs/Redimentos'
import Pagamentos from './../../dirfs/Pagamentos'

export default {
	props: {
		fornecedorId: {
			type: String,
			default: () => null
		},

		dataServico: {
			type: Object,
			default: () => {}
		}
	},

	components: {
		Rendimentos,
		Pagamentos
	},

	data() {
		return {
			anosCalendario: [],
			anoCalendario: null,
			dirf: null,
			md: 2,
			lg: 2,
			xl: 1
		}
	},

	methods: {
		obterAnosCalendario() {
			this.$store.dispatch('addRequest')
			let promisse
			if (this.fornecedorId) {
				promisse = this.dataServico.obterAnosCalendario(this.fornecedorId)
			} else {
				promisse = DirfsServicos.obterAnosCalendario()
			}
			promisse.then(response => {
				if (response) {
					if (response.success) {
						this.anosCalendario = response.data
						this.anoCalendario = this.anosCalendario
							? this.anosCalendario[0]
							: null
						if (this.anoCalendario) {
							this.obterDirf()
						}
					} else {
						this.$toast.error(
							'Erro ao obter anos-calendário',
							'ERROR',
							this.$toastConfig.error
						)
					}
				}
				this.$store.dispatch('removeRequest')
			})
		},

		obterDirf() {
			this.$store.dispatch('addRequest')
			let promisse
			if (this.fornecedorId) {
				promisse = this.dataServico.obterDirf(
					this.fornecedorId,
					this.anoCalendario
				)
			} else {
				promisse = DirfsServicos.obterDirf(this.anoCalendario)
			}
			promisse.then(response => {
				if (response) {
					if (response.success) {
						this.dirf = response.data
					} else {
						this.$toast.error(
							'Erro ao obter DIRF',
							'ERROR',
							this.$toastConfig.error
						)
					}
				}
				this.$store.dispatch('removeRequest')
			})
		},

		obterDirfsServicos() {
			if (this.fornecedorId) {
				return this.dataServico
			}
			return DirfsServicos
		}
	},

	created() {
		this.obterAnosCalendario()
	},

	computed: {},

	watch: {
		anoCalendario() {
			this.obterDirf()
		}
	}
}
</script>
